/**
 * Defines the authenticated realtime notification protocol without making sockets durable state.
 */
import { z } from "zod";
export const RealtimeNotificationEventName = "notification.created.v1";
export const RealtimeHandshakeAuthSchema = z
    .object({
    accessToken: z.string().min(1).max(8_192),
})
    .strict();
/**
 * Internal Redis message emitted only after durable notifications have committed.
 */
export const RealtimeNotificationDispatchSchema = z
    .object({
    companyId: z.uuid(),
    eventId: z.uuid(),
    notificationIds: z.array(z.uuid()).min(1).max(1_000),
    occurredAt: z.iso.datetime({ offset: true }),
})
    .strict();
/**
 * Minimal event visible to an authenticated browser. Details remain recoverable through the API.
 */
export const RealtimeNotificationEventSchema = z
    .object({
    eventId: z.uuid(),
    notificationId: z.uuid(),
    occurredAt: z.iso.datetime({ offset: true }),
})
    .strict();
//# sourceMappingURL=RealtimeContract.js.map